export default function HeadingLarge({ children }) {
  return (<h2 className="text-2xl md:text-4xl font-medium tracking-tight font-[Outfit]">{children}</h2>)
}
